export default (date) => {

  const zeroPad = num => {
    return num.toString().padStart(2, '0');
  };

  const parsedTime = `${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())}:${zeroPad(date.getSeconds())}`;
  const parsedDate = `${zeroPad(date.getDate())}/${zeroPad(date.getMonth() + 1)}/${zeroPad(date.getFullYear())}`;

  return `${parsedTime} ${parsedDate}`;

};


// WEBPACK FOOTER //
// ./src/components/universal/utils/readableDate.js